<template>
	<div>
		<Alert class="mb-4"/>
		<UiForm id="reset-password-form" @submit.prevent="onFormSubmit">
			<TextInput v-model="form.email" type="email" :required="true" :label="trans('users.labels.email')" name="email" class="mb-2"/>
			<TextInput v-model="form.password" type="password" :required="true" :label="trans('users.labels.password')" name="password" class="mb-2"/>
			<TextInput v-model="form.passwordConfirm" type="password" :required="true" :label="trans('users.labels.confirm_password')" name="password-confirm" class="mb-4"/>
			<div class="text-center">
				<UiButton type="submit" :label="trans('global.buttons.submit')" @click="onFormSubmit"/>
			</div>
		</UiForm>
	</div>
</template>

<script>
	import AuthService from "@/services/AuthService";
	import { reactive, defineComponent } from "vue";
	import { useRoute } from "vue-router";
	import { trans } from "@/helpers/i18n";
	import { useAlertStore } from "@/stores";
	import { getResponseError } from "@/helpers/api";
	import TextInput from "@/views/components/input/TextInput";
	import UiButton from "@/views/components/input/UiButton.vue";
	import Alert from "@/views/components/Alert";
	import UiForm from "@/views/components/UiForm.vue";

	export default defineComponent({
		name: "ResetPasswordForm",
		components: {
			UiForm,
			Alert,
			UiButton,
			TextInput
		},
		setup () {

			const authService = new AuthService();
			const alertStore = useAlertStore();
			const route = useRoute();
			const form = reactive({
				email: null,
				password: null,
				passwordConfirm: null
			});

			function onFormSubmit () {
				const payload = {
					email: form.email,
					password: form.password,
					password_confirmation: form.passwordConfirm,
					token: route.query.token
				};
				authService.resetPassword(payload)
					.then((response) => (alertStore.success(response.data.message)))
					.catch((error) => (alertStore.error(getResponseError(error))));
			}

			return {
				onFormSubmit,
				form,
				trans
			};
		}
	});
</script>
